import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import TradePanel from './components/TradePanel'; // Time-Based
import PointsBasedTrade from './components/PointBasedTrade'; // Points-Based

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<TradePanel />} /> {/* Default: Time-Based Trading */}
        <Route path="/points-based" element={<PointsBasedTrade />} />
      </Routes>
    </Router>
  );
}
